var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    {
      staticClass: "evaluation-item",
      attrs: {
        to: {
          name: "evaluation-detail",
          params: { evaluationId: _vm.evaluation.id },
        },
      },
    },
    [
      _c("div", { staticClass: "inner" }, [
        _c("div", { staticClass: "client-data" }, [
          _vm._v(" " + _vm._s(_vm.evaluation.name || "Desconocido") + " "),
          _c("span", { staticClass: "client-id" }, [
            _vm._v(_vm._s(_vm.evaluation.idNumber || "Desconocido")),
          ]),
        ]),
        _c("div", { staticClass: "evaluation-data" }, [
          _c("div", { staticClass: "top" }, [
            _c("small", [
              _vm._v(
                _vm._s(_vm.formatDate(_vm.evaluation.evaluationDate) || "n/e")
              ),
            ]),
            _c("small", { staticClass: "is-primary" }, [
              _vm._v(_vm._s(_vm.evaluation.executive || "Desconocido")),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "stack-tag" },
            [
              _c(
                "b-tag",
                { attrs: { type: "is-primary is-light", rounded: "" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(_vm.evaluation.future ? "future" : "immediate")
                      ) +
                      " "
                  ),
                ]
              ),
              _vm.evaluation.oneStatus
                ? _c(
                    "b-tag",
                    {
                      attrs: {
                        "data-status": "oneStatus",
                        type: "is-info is-small is-light",
                        rounded: "",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.formatEstate(_vm.evaluation.oneStatus.name)
                          )
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              !_vm.evaluation.oneStatus
                ? _c(
                    "b-tag",
                    {
                      attrs: {
                        "data-status": "oneStatus",
                        type: _vm.tagClass,
                        rounded: "",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.formatEstate(_vm.labelTooltip))),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }